import React from 'react';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@store';
import ErrorBoundaryHandler from '@components/ErrorBoundaryHandler';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from 'react-oidc-context';
import { userManager } from '@auth/userManager';

if (typeof window !== 'undefined') {
  const originalError = console.error;
  console.error = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('useLayoutEffect')) {
      return;
    }
    originalError.call(console, ...args);
  };
}

const staleTime = 1000 * 60 * 15;
const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: staleTime,
      refetchOnWindowFocus: false
    }
  }
});
const isProd = process.env.NODE_ENV === 'production';

root.render(
  <AuthProvider
    userManager={userManager}
    onSigninCallback={() =>
      // Only strip the ?code/&state from the URL; keep the path so react-router stays in sync.
      // The actual post-login navigation happens in <AuthCallback> via react-router's <Navigate>.
      window.history.replaceState({}, document.title, window.location.pathname)
    }>
    <Router>
      <Provider store={store}>
        <ErrorBoundaryHandler>
          <QueryClientProvider client={queryClient}>
            <App />
            {!isProd && <ReactQueryDevtools />}
          </QueryClientProvider>
        </ErrorBoundaryHandler>
      </Provider>
    </Router>
  </AuthProvider>
);
